import { defineNuxtPlugin } from '#app'

// Set correct word endings
const getWordEnding = (n: number, textForms: Array<string>) => {
    // n - the reminder of division by 100 modulo n - the significant part of the number
    n = Math.abs(n) % 100
    // n1 - the reminder of division by 10 n
    const n1 = n % 10
    // Return the third word form (2-4 items)
    if (n > 10) {
        return textForms[2]
    }
    // Return the second word form (2-4 items)
    if (n1 > 1 && n1 < 5) {
        return textForms[1]
    }
    // Return the first word form (1 item)
    if (n1 === 1) {
        return textForms[0]
    }
    // Return the third word form (2-4 items)
    return textForms[2]
}

export default defineNuxtPlugin(() => {
    return {
        provide: {
            wordEndings: (count: number, wordForms: Array<string>) =>
                getWordEnding(count, wordForms),
        },
    }
})
